// extracted by mini-css-extract-plugin
export default {"card":"DIDSMSCard_card__iNEW-","cardHeader":"DIDSMSCard_cardHeader__1N2FA","cardHeaderDate":"DIDSMSCard_cardHeaderDate__CcTOJ","cardText":"DIDSMSCard_cardText__E7ClG"};